export default "__VITE_ASSET__Dq9UXUMB__"